import * as _ from 'lodash';
import type { ServiceFilter } from '../../../types';
import { window } from '../../../globals';

const height = 500;
const width = 500;

/**
 * Redirect to the GitHub app installation URL.
 */
export const redirectToGithubAppInstallation = () => {
  window.open(
    '/api/services/github-app/installation-url',
    '_blank',
    // Open the window in the center of the screen
    `popup=yes,width=${width},height=${height},top=${(window.innerHeight - height) / 2},left=${(window.innerWidth - width) / 2}`,
  );
};

/**
 * Determine if the GitHub App is installed.
 * @returns 'installed' if the GitHub App is installed, 'missing' if it is not, and 'unknown' if it cannot be determined.
 */
export function hasGithubAppInstallation({
  isGithubApp,
  filters,
}: {
  isGithubApp: boolean;
  filters: ServiceFilter[];
}): 'installed' | 'missing' | 'unknown' {
  if (!isGithubApp) {
    return 'unknown';
  }
  return filters.length > 0 ? 'installed' : 'missing';
}

/**
 * They are used to determine if the installation or update process is complete.
 */
const setupActions = new Set(['install', 'update']);

/**
 * Check if the GitHub App installation process is complete and close the window if it is.
 */
export function completeGithubAppInstallationProcess(setupAction: string, installationId: number | null) {
  const isCompletingGithubAppInstallation = setupActions.has(setupAction) && !_.isNil(installationId);
  if (isCompletingGithubAppInstallation) {
    window.close();
  }
}
